import './how-to-create-info-page.scss';
import { HowToCreateSteps } from '@components/how-to-create-steps/how-to-create-steps';
import { PageHeader } from '@components/page-header/page-header';
import { useTranslation } from '@translations';

export const HowToCreateInfoPage = () => {
    const { howToCreateInfo } = useTranslation();
    const { header, ingress } = howToCreateInfo;

    return (
        <div className="info-page">
            <PageHeader header={header} ingress={ingress} />
            <HowToCreateSteps />
        </div>
    );
};
